<template style="overflow: hidden;">
  <v-app id="inspire">
    <v-card class="overflow-hidden">
      <v-app-bar
          absolute
          color="#6A76AB"
          dark
          shrink-on-scroll
          prominent
          src="https://picsum.photos/1920/1080?random"
          fade-img-on-scroll
          scroll-target="#scrolling-techniques-3"
      >
        <template v-slot:img="{ props }">
          <v-img
              v-bind="props"
              gradient="to top right, rgba(100,115,201,.7), rgba(25,32,72,.7)"
          ></v-img>
        </template>

<!--        <v-app-bar-nav-icon></v-app-bar-nav-icon>-->
        <template>
          <v-icon>mdi-panda</v-icon>
        </template>
        <v-toolbar-title>pandaquests</v-toolbar-title>

        <div class="flex-grow-1"></div>

        <v-btn icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>

        <v-btn icon>
          <v-icon>mdi-heart</v-icon>
        </v-btn>

        <v-btn icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>

        <template v-slot:extension>
          <v-tabs
              align-with-title
              background-color="transparent"
          >
            <v-tab>Tab 1</v-tab>
            <v-tab>Thoughts</v-tab>
            <v-tab>Tab 3</v-tab>
            <v-tab>Tab 4</v-tab>
            <v-tab>Tab 5</v-tab>
            <v-tab>Tab 6</v-tab>
          </v-tabs>
        </template>
      </v-app-bar>
      <v-sheet
          id="scrolling-techniques-3"
          class="overflow-y-auto"
          max-height="600"
      >
        <v-container style="height: 100vh;">
          <v-card
              max-width="100%"
              class="mx-auto"
          >
            <v-list-item>
              <v-list-item-avatar color="grey"></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
                <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
            ></v-img>

            <v-card-text>
              Visit ten places on our planet that are undergoing the biggest changes today.
            </v-card-text>

            <v-card-actions>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Read
              </v-btn>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Bookmark
              </v-btn>
              <div class="flex-grow-1"></div>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card
              max-width="100%"
              class="mx-auto"
          >
            <v-list-item>
              <v-list-item-avatar color="grey"></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
                <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
            ></v-img>

            <v-card-text>
              Visit ten places on our planet that are undergoing the biggest changes today.
            </v-card-text>

            <v-card-actions>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Read
              </v-btn>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Bookmark
              </v-btn>
              <div class="flex-grow-1"></div>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card
              max-width="100%"
              class="mx-auto"
          >
            <v-list-item>
              <v-list-item-avatar color="grey"></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
                <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
            ></v-img>

            <v-card-text>
              Visit ten places on our planet that are undergoing the biggest changes today.
            </v-card-text>

            <v-card-actions>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Read
              </v-btn>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Bookmark
              </v-btn>
              <div class="flex-grow-1"></div>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card
              max-width="100%"
              class="mx-auto"
          >
            <v-list-item>
              <v-list-item-avatar color="grey"></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
                <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
            ></v-img>

            <v-card-text>
              Visit ten places on our planet that are undergoing the biggest changes today.
            </v-card-text>

            <v-card-actions>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Read
              </v-btn>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Bookmark
              </v-btn>
              <div class="flex-grow-1"></div>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card
              max-width="100%"
              class="mx-auto"
          >
            <v-list-item>
              <v-list-item-avatar color="grey"></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
                <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
            ></v-img>

            <v-card-text>
              Visit ten places on our planet that are undergoing the biggest changes today.
            </v-card-text>

            <v-card-actions>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Read
              </v-btn>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Bookmark
              </v-btn>
              <div class="flex-grow-1"></div>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card
              max-width="100%"
              class="mx-auto"
          >
            <v-list-item>
              <v-list-item-avatar color="grey"></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
                <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
            ></v-img>

            <v-card-text>
              Visit ten places on our planet that are undergoing the biggest changes today.
            </v-card-text>

            <v-card-actions>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Read
              </v-btn>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Bookmark
              </v-btn>
              <div class="flex-grow-1"></div>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card
              max-width="100%"
              class="mx-auto"
          >
            <v-list-item>
              <v-list-item-avatar color="grey"></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
                <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
            ></v-img>

            <v-card-text>
              Visit ten places on our planet that are undergoing the biggest changes today.
            </v-card-text>

            <v-card-actions>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Read
              </v-btn>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Bookmark
              </v-btn>
              <div class="flex-grow-1"></div>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card
              max-width="100%"
              class="mx-auto"
          >
            <v-list-item>
              <v-list-item-avatar color="grey"></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
                <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
            ></v-img>

            <v-card-text>
              Visit ten places on our planet that are undergoing the biggest changes today.
            </v-card-text>

            <v-card-actions>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Read
              </v-btn>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Bookmark
              </v-btn>
              <div class="flex-grow-1"></div>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card
              max-width="100%"
              class="mx-auto"
          >
            <v-list-item>
              <v-list-item-avatar color="grey"></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
                <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
            ></v-img>

            <v-card-text>
              Visit ten places on our planet that are undergoing the biggest changes today.
            </v-card-text>

            <v-card-actions>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Read
              </v-btn>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Bookmark
              </v-btn>
              <div class="flex-grow-1"></div>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card
              max-width="100%"
              class="mx-auto"
          >
            <v-list-item>
              <v-list-item-avatar color="grey"></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
                <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
            ></v-img>

            <v-card-text>
              Visit ten places on our planet that are undergoing the biggest changes today.
            </v-card-text>

            <v-card-actions>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Read
              </v-btn>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Bookmark
              </v-btn>
              <div class="flex-grow-1"></div>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card
              max-width="100%"
              class="mx-auto"
          >
            <v-list-item>
              <v-list-item-avatar color="grey"></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
                <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
            ></v-img>

            <v-card-text>
              Visit ten places on our planet that are undergoing the biggest changes today.
            </v-card-text>

            <v-card-actions>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Read
              </v-btn>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Bookmark
              </v-btn>
              <div class="flex-grow-1"></div>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card
              max-width="100%"
              class="mx-auto"
          >
            <v-list-item>
              <v-list-item-avatar color="grey"></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
                <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
            ></v-img>

            <v-card-text>
              Visit ten places on our planet that are undergoing the biggest changes today.
            </v-card-text>

            <v-card-actions>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Read
              </v-btn>
              <v-btn
                  text
                  color="deep-purple accent-4"
              >
                Bookmark
              </v-btn>
              <div class="flex-grow-1"></div>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
      </v-sheet>
    </v-card>
  </v-app>
</template>

<script>
  export default {
    props: {
      source: String,
    },
    data: () => ({
      bottomNav: 3,
      show: false,
    }),
    created () {
      this.$vuetify.theme.dark = true
    },
  }
</script>
